export enum EntityType {
  PROFILE = 'profile',
  VACANCY = 'vacancy',
  SHORTLIST = 'shortlist',
}

export enum EventType {
  // Profile lifecycle
  PROFILE_CREATED = 'profile.created',
  PROFILE_UPDATED = 'profile.updated',
  PROFILE_AI_UPDATED = 'profile.ai_updated',
  PROFILE_MERGED = 'profile.merged',
  PROFILE_BOOKED = 'profile.booked',
  PROFILE_UNBOOKED = 'profile.unbooked',
  PROFILE_DISMISSED = 'profile.dismissed',

  // Vacancy lifecycle
  VACANCY_CREATED = 'vacancy.created',
  VACANCY_UPDATED = 'vacancy.updated',
  VACANCY_STATUS_CHANGED = 'vacancy.status_changed',
  VACANCY_RECRUITER_CHANGED = 'vacancy.recruiter_changed',
  VACANCY_TEAM_CHANGED = 'vacancy.team_changed',
  VACANCY_DELETED = 'vacancy.deleted',

  // Shortlist (candidate on vacancy) — stored profile-primary (entityId=profileId)
  SHORTLIST_ADDED = 'shortlist.added',
  SHORTLIST_STATUS_CHANGED = 'shortlist.status_changed',
  SHORTLIST_HIRED = 'shortlist.hired',
  SHORTLIST_REJECTED = 'shortlist.rejected',
  SHORTLIST_REMOVED = 'shortlist.removed',

  // Sub-entity activities
  FILE_UPLOADED = 'file.uploaded',
  FILE_DELETED = 'file.deleted',
  COMMENT_ADDED = 'comment.added',
  COMMENT_DELETED = 'comment.deleted',
  NOTIFICATION_SENT = 'notification.sent',
}

export interface Event {
  createdAt?: Date;
  createdBy: number;
  entityId: number;
  entityType: EntityType;
  eventType: EventType;
  id: string;
  payload: Record<string, unknown>;
  portalId: number;
  relatedEntityId?: number | null;
  relatedEntityType?: EntityType | null;
}
export interface Query {
  portalId: number;
  entityId: number;
  entityType: EntityType;
  dateFrom?: string;
  dateTo?: string;
  // When true, also match events where the entity is the related party
  // (relatedEntityId/relatedEntityType) — used by the dashboard chronology page.
  includeRelated?: boolean;
}

export interface Payload {
  readonly portalId: number;
  readonly entityId: number;
  readonly entityType: EntityType;
  readonly eventType: EventType;
  readonly payload: Record<string, unknown>;
  readonly relatedEntityId?: number | null;
  readonly relatedEntityType?: EntityType | null;
  readonly createdAt: string;
  readonly createdBy: number;
}

// Bulk-reassigns events to a new primary entity. Used when merging profiles:
// events of the merged duplicates are moved onto the surviving profile, and
// on restore moved back. Scope is either `fromEntityIds` (all matching events)
// or an explicit `eventIds` set (precise reverse without touching newer events).
export interface Reassign {
  readonly portalId: number;
  readonly entityType: EntityType;
  readonly toEntityId: number;
  readonly fromEntityIds?: number[];
  readonly eventIds?: string[];
}
